export const CLIENT_INVOICE_HEADER = [
  { key: "patientName", label: " Patient Name", style: { width: "21%", minWidth: "100px" }, },
  { key: "taskName", label: "Doctor", style: { width: "9%", minWidth: "100px" } },
  { key: "noOfPages", label: "No. of Pages", isNumeric: true },
  { key: "noOfLines", label: "No. of Lines", isNumeric: true },
  { key: "rateType", label: "Rate Type" },
  { key: "dateUploaded", label: "Uploaded On | By", style: { width: "12%", minWidth: "120px" },  },
  { key: "rate", label: "Rate", isNumeric: true,style: { width: "8%", minWidth: "80px" },  },
  { key: "amount", label: "Amount", isNumeric: true,  style: { width: "12%", minWidth: "120px" },},
  { key: "invoiceStatus", label: "Status",style: { width: "8%", minWidth: "120px" }, },
  { key: "action", label: "Action",style: { width: "5%", minWidth: "80px" }, },
];

export const INVOICE_NOTES_INFO_HEADER = [
  { key: "SrNo", label: "Sr. No"},
  { key: "noteCategoryDesc", label: "Category"},
  { key: "noteContent", label: "Description"},
  { key: "uploadedOn", label: "Uploaded On"},
];

export const INVOICE_CHANGE_LOG= [
  {
    key: "userRole",
    label: "User / Role",
    style: { width: "10%" },
  },
  {
    key: "dateOfAppointmentFormat",
    label: "Appointment Date & Time",
    style: { width: "10%" },
  },
  {
    key: "oldValue",
    label: "Old Value",
    style: { width: "10%" },
  },
  {
    key: "newValue",
    label: "New Value",
    style: { width: "10%" },
  },
  {
    key: "auditChangedByName",
    label: "Updated By",
    style: { width: "7%" },
  },
  {
    key: "auditChangedOn",
    label: "Created / Updated On",
    style: { width: "10%" },
  },
];

export const INVOICE_RESOLVE_MISSING_PAGE_COUNT = [
  {
    key: "userRole",
    label: "User / Role",
    style: { width: "10%" },
  },
  {
    key: "examType",
    label: "Exam Type",
    style: { width: "10%" },
  },
  {
    key: "no_Of_Pages",
    label: "No of Pages",
    style: { width: "10%" },
  },
  {
    key: "no_of_Lines",
    label: "No of Lines",
    style: { width: "10%" },
    isNumeric: true,
  },
  {
    key: "rateType",
    label: "Rate Type",
    style: { width: "10%" },
  },
  {
    key: "uploadedOn",
    label: "Uploaded On",
    style: { width: "12%" },
  },
  {
    key: "rate",
    label: "Rate",
    style: { width: "10%" },
  },
  {
    key: "invoicestatus",
    label: "Invoice Status",
    style: { width: "10%" },
  },
  {
    key: "amount",
    label: "Amount",
    style: { width: "10%" },
  },
];

export const INVOICE_RESOLVE_MISSING_LINE_COUNT = [
  {
    key: "userRole",
    label: "User / Role",
    style: { width: "10%" },
  },
  {
    key: "examType",
    label: "Exam Type",
    style: { width: "10%" },
  },
  {
    key: "no_Of_MissingPages",
    label: "No of Pages",
    style: { width: "10%" },
    isNumeric: true,
  },
  {
    key: "no_of_Lines_missingLineCount",
    label: "No of Lines",
    style: { width: "10%" },
  },
  {
    key: "rateType",
    label: "Rate Type",
    style: { width: "10%" },
  },
  {
    key: "uploadedOn",
    label: "Uploaded On",
    style: { width: "12%" },
  },
  {
    key: "rate",
    label: "Rate",
    style: { width: "10%" },
  },
  {
    key: "invoicestatus",
    label: "Invoice Status",
    style: { width: "10%" },
  },
  {
    key: "amount",
    label: "Amount",
    style: { width: "10%" },
  },
];

export const INVOICE_RESOLVE_LINEITEM_EXCEPTIONS = [
  {
    key: "noteCategoryDesc",
    label: "Note Category",
    style: { width: "15%" },
  },
  {
    key: "noteContent",
    label: "Note Description",
    style: { width: "30%" },
  },
  {
    key: "uploadedOn",
    label: "Uploaded On | By",
    style: { width: "20%" },
  },
];

export const INVOICE_RESOLVE_MULTIPLE_CONGF_SETUP = [
  {
    key: "userRole",
    label: "User(Role)",
    style: { width: "10%" },
  },
  {
    key: "rateType",
    label: "Rate Type",
    style: { width: "10%" },
  },
  {
    key: "currency",
    label: "Currency",
    style: { width: "10%" },
  },
  {
    key: "effectiveFrom",
    label: "Effective From",
    style: { width: "10%" },
  },
  {
    key: "effectiveTo",
    label: "Effective To",
    style: { width: "10%" },
  },
  {
    key: "uploadedOnBy",
    label: "Uploaded On | By",
    style: { width: "10%" },
  },
];